import React from 'react';
import ChipMui, { ChipProps } from '@material-ui/core/Chip';

export const Chip: React.FC<ChipProps> = ({ children, ...rest }) => {
	return <ChipMui {...rest} />;
};
